import SimpleAutocompleteSelect from "../../../../../components/autocomplete/SimpleAutocompleteSelect";
import { useUser } from "../../../../../domains/session/store/sessionStore";
import { CrudFormType } from "../../../../../shared/form/types/FormTypes";
import { useLangLabels } from "../../../../../shared/lang/services/useLangLabels";
import { useGetAllPLCs } from "../services/plcService";
import CreateUpdatePLCForm from "./CreateUpdatePLCForm";

interface SelectPLCProps {
  onChange: (value: any) => void;
  defaultValue?: string;
  error?: string;
  disabled?: boolean;
}

const SelectPLC: React.FC<SelectPLCProps> = ({ onChange, defaultValue, error, disabled }) => {
  const { lang } = useLangLabels();
  const { data: user } = useUser();

  const { data: plcs } = useGetAllPLCs();

  const plcOptions = plcs?.map((plc: any) => ({ label: plc.plc || "" })) || [];

  return (
    <SimpleAutocompleteSelect
      error={error}
      items={plcOptions}
      defaultValue={defaultValue}
      label={lang.instruments.plc}
      onChange={onChange}
      showTitle={"label"}
      disabled={disabled}
    >
      {user?.type !== "O" && <CreateUpdatePLCForm actionType={CrudFormType.create} />}
    </SimpleAutocompleteSelect>
  );
};

export default SelectPLC;
